import { accessTokenKey, idTokenKey } from "../entries"
import { requestRefresh } from "../requests/users_requests"



export const setAccessToken = (accessToken) => {
    accessToken = JSON.stringify(accessToken)
    localStorage.setItem(accessTokenKey, accessToken)
}


export const removeAccessToken = () => {
    localStorage.removeItem(accessTokenKey)
}


export const resolveAccessToken = (accessToken) => {
    return JSON.parse(accessToken)
}


export const getAccessToken = () => {
    const accessToken = localStorage.getItem(accessTokenKey)
    if (accessToken) {
        return resolveAccessToken(accessToken)
    }
    else {
        return false
    }
}


export const setIdToken = (idToken) => {
    idToken = JSON.stringify(idToken)
    localStorage.setItem(idTokenKey, idToken)
}


export const removeIdToken = () => {
    localStorage.removeItem(idTokenKey)
}


export const resolveIdToken = (idToken) => {
    try {
        return JSON.parse(idToken)
    } catch {
        return null
    }
}


export const getIdToken = () => {
    const idToken = localStorage.getItem(idTokenKey)
    if (idToken) {
        return resolveIdToken(idToken)
    }
    else {
        return false
    }
}


// export const secureAPICall = async ({ endpoint, body = {}, method = "POST", options = {}, verbose = false, once = true }) => {
//     const accessToken = getAccessToken().access_token

//     const response = await fetch(endpoint, {
//         method: method,
//         body: body,
//         ...options,
//         headers: {
//             ...options.headers,
//             Authorization: `Bearer ${accessToken}`
//         },
//         credentials: "include"
//     })

//     if (response.status === 401 && once) {
//         return requestRefresh({}).then((data) => {
//             devLog("refreshing..")
//             setAccessToken(data.access_token)
//             setIdToken(data.id_token)
//             return secureAPICall({ endpoint: endpoint, body: body, method: method, options: options, verbose: verbose, once: false })
//         }).catch((error) => {
//             throw new Error("Session expired. Please log in again.")
//         })
//     }
//     else if (response.status === 403) {
//         throw new Error("Unauthorized action. You do not have permission.")
//     }
//     else {
//         const result = await response.json()
//         if (!response.ok) {
//             throw new Error(result.detail)
//         }
//         if (verbose) {
//             devLog(result.status, result.message)
//             devLog(result)
//         }
//         return result.data

//     }
// }